enum MergeDuplicatesSettingValue {
  USER = "user",
  TEAM = "teams",
  ORGANIZATION = "organization",
}

export default MergeDuplicatesSettingValue;
